var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0156 18.9844V5.01562H1.98438V18.9844H12.0156ZM12.0156 1.03125C12.5469 1.03125 13 1.23437 13.375 1.64062C13.7812 2.01562 13.9844 2.46875 13.9844 3V21C13.9844 21.5312 13.7812 22 13.375 22.4062C13 22.8125 12.5469 23.0156 12.0156 23.0156H1.98438C1.45312 23.0156 0.984375 22.8125 0.578125 22.4062C0.203125 22 0.015625 21.5312 0.015625 21V3C0.015625 2.46875 0.203125 2 0.578125 1.59375C0.984375 1.1875 1.45312 0.984375 1.98438 0.984375L12.0156 1.03125Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.fd32824d85cc2d12fd8619f65954fb6c.svg";
export { ForwardRef as ReactComponent };